import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UsuarioVM } from './../../../_entities/usuarios/UsuarioVM';
import { environment } from './../../../../environments/environment';
import { ClienteVM } from './../../../_entities/clientes/ClienteVM';
import { FiltroProductos } from './../../../_entities/productos/filtro-productos';
import { PanelCiudadano } from '../../../_entities/panelCiudadano/panelCiudadano';

@Injectable({
	providedIn: 'root'
})
export class FiltroProductosService {

	constructor(private http: HttpClient) { }

	obtenerClientes(): Observable<ClienteVM[]> {
		return this.http.get<ClienteVM[]>(`${environment.API_SECURITY}/api/Reportes/ClientesReportes`);
	}

	obtenerUsuariosIdCliente(idCliente: number): Observable<UsuarioVM[]> {
		return this.http.get<UsuarioVM[]>(`${environment.API_SECURITY}/api/Reportes/UsuariosClienteReportes/${idCliente}`);
	}

	obtenerProductosIdUsuario(idUsuario: string): Observable<FiltroProductos[]>{
		return this.http.get<FiltroProductos[]>(`${environment.API_SECURITY}/api/vehiculo/ProductosIdUsuario`, {
			params: {
				idUsuario
			}
		});
	}

	obtenerPaneles(): Observable<PanelCiudadano[]> {
		return this.http.get<PanelCiudadano[]>(`${environment.API_SECURITY}/api/PanelCiudadano/PanelAlarmado`);
	  }

	  obtenerPanelesMapa(): Observable<PanelCiudadano[]> {
		return this.http.get<PanelCiudadano[]>(`${environment.API_SECURITY}/api/PanelCiudadano/PanelMapa`);
	  }

}


